/**
 * PipelineSection - Reusable Component for Pipeline Cards
 * 
 * This component displays a list of pipeline cards using SelectCard.
 * It's designed to be reusable across multiple DPR-related pages.
 * 
 * Props:
 * - pipelines: Array of pipeline objects
 * - isLoading: Boolean indicating loading state
 * - onPipelineSelect: Callback function when a pipeline is clicked
 */

import React from 'react';
import { CardGrid, SelectCard, Spinner } from '@crc-evans/ui-components';
import './PipelineSection.css';

const PipelineSection = ({ pipelines = [], isLoading = false, onPipelineSelect }) => {
  if (isLoading) {
    return (
      <div className="pipeline-section">
        <div className="pipeline-section-loading">
          <Spinner variant="inline" size="medium" />
          <span>Loading pipelines...</span>
        </div>
      </div>
    );
  }

  if (pipelines.length === 0) {
    return (
      <div className="pipeline-section">
        <div className="pipeline-section-empty">
          <p>No pipeline sections found.</p>
        </div>
      </div>
    );
  }

  return (
    <div className="pipeline-section">
      <CardGrid columns={1}>
        {pipelines.map((pipeline) => (
          <SelectCard
            key={pipeline.id}
            id={pipeline.id}
            title={pipeline.pipelineSection || pipeline.name || `Pipeline ${pipeline.id}`}
            size="medium"
            onClick={() => onPipelineSelect && onPipelineSelect(pipeline)}
          />
        ))}
      </CardGrid>
    </div>
  );
};

export default PipelineSection;
